export const featureToggles = {
  showOffsetAccount: true,
  showExtraRepayment: true,
  showUpfrontCosts: true,
};
